module.exports = __webpack_public_path__ + "media/images/icons/script-df401a09e0bca36e297f7930360a70ee.svg";